var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlashcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 28.3l-1.3 1.3a2.22 2.22 0 01-3 0l-9-9.06A2.09 2.09 0 015 19a2.07 2.07 0 01.63-1.5l5-5a2.09 2.09 0 011.51-.63 2.24 2.24 0 01.73.13v12.74a3.56 3.56 0 003.55 3.56z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.44 9.8a2.14 2.14 0 00-2.13 2.14v12.8a2.13 2.13 0 002.13 2.13h7.12a2.13 2.13 0 002.13-2.13v-12.8a2.14 2.14 0 00-2.13-2.14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28.3l1.3 1.3a2.22 2.22 0 003 0l9-9.06A2.09 2.09 0 0035 19a2.07 2.07 0 00-.63-1.5l-5-5a2.09 2.09 0 00-1.51-.63 2.24 2.24 0 00-.73.13v12.74a3.56 3.56 0 01-3.55 3.56z"
  })));
}
export default SvgFlashcard;